import { render, staticRenderFns } from "./publications.vue?vue&type=template&id=6760e03b&scoped=true&"
import script from "./publications.vue?vue&type=script&lang=js&"
export * from "./publications.vue?vue&type=script&lang=js&"
import style0 from "./publications.vue?vue&type=style&index=0&id=6760e03b&scoped=true&lang=css&"
import style1 from "./publications.vue?vue&type=style&index=1&id=6760e03b&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6760e03b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/buildhome/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileContent } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VProgressCircular } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDialog,VDivider,VFlex,VIcon,VImg,VLayout,VList,VListTile,VListTileContent,VListTileTitle,VMenu,VProgressCircular,VTextarea})
